import { render, staticRenderFns } from "./BranchNavbar.vue?vue&type=template&id=77070482&scoped=true"
import script from "./BranchNavbar.vue?vue&type=script&lang=js"
export * from "./BranchNavbar.vue?vue&type=script&lang=js"
import style0 from "./BranchNavbar.vue?vue&type=style&index=0&id=77070482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77070482",
  null
  
)

export default component.exports